import React, { useRef, useEffect, useState } from "react";
import FormModal from "../../widgets/FormModal";

function Tracking() {
  const sectionRef = useRef(null);
  const leftRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  const [trackingState, setTracking] = useState([
    { title: "All your health data in one place", description: "250+ genetic & metabolic markers decoded into a single, easy-to-understand report, delivered in the TRIGR app." },
    { title: "Upload your past reports", description: "Combine existing lab results with your genetic profile for deeper, more actionable insights." },
    { title: "Your personalized health blueprint", description: "Custom diet, supplement, fitness, and recovery plans built around your DNA and metabolic data." },
    { title: "Access to Expert Team", description: "Connect with doctors, geneticists, nutritionists, and health coaches for personalized guidance." },
    { title: "Access to the TRIGR App", description: "Don’t stop at the report; track your progress, sync wearables, and get real-time guidance through the TRIGR app." },
    { title: "Access to EPLIMO Experts & Clinics", description: "Connect with a network of trusted practitioners, clinics, and wellness centers for advanced therapies and interventions." }
  ]);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current || !leftRef.current) return;

      const sectionTop = sectionRef.current.getBoundingClientRect().top;
      const sectionHeight = sectionRef.current.offsetHeight;
      const leftHeight = leftRef.current.offsetHeight;
      // When section is scrolled into view
      if (sectionTop <= 0 && Math.abs(sectionTop) + leftHeight < sectionHeight) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

    const [show, setShow] = useState(false);
    const openIframeWindow = () => {
      setShow(!show);
    }

  return (
    <section className="a_hyper_sec pt-2" ref={sectionRef}>
      <div className="container">
        <div className="row">
          {/* Left Sticky Column */}
          <div
            className="col-md-5 pe-md-5 text-center text-md-start mb-5"

          >
            <div ref={leftRef}
              style={{
                position: isSticky ? "sticky" : "relative",
                top: isSticky ? "20px" : "auto",
              }}>

              <h2 className="hadding mb-3">
                A Hyper-Personalized Plan Like Never Before
              </h2>
              <p className="mb-3">
                EPLIMO uncovers your unique risks and provides solutions
                tailored to your genetic code —covering 270+ health conditions
                before they become problems
              </p>
              <a className="btn" onClick={() => openIframeWindow()}>
                Join EPLIMO<sup className="sup-font">TM</sup> Program
              </a>
            </div>
          </div>

          {/* Right Scroll Column */}
          <div className="col-md-7">
            <div className="row">
              {trackingState.map((val, i) => (
                <div className="col-md-6 mb-3" key={i}>
                  <img
                    src={`/assets/img/a_hyper_sec${i + 1}.webp`}
                    alt="Hyper"
                    className="w-100"
                  />
                  <h4>{val.title}</h4>
                  <p>
                    {val.description}
                    {/* Lorem ipsum content for box {i + 1}. This simulates your
                    right column scrolling content. */}
                  </p>
                </div>
              ))}
            </div>
             <FormModal show={show} setShow={setShow} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Tracking;
